/* eslint-disable max-len */
export default {
    create: {
        cancelButton: {
            buttons: ['Refuse refund', 'Back to the design', 'Confirm'],
            text: 'Confirm the refusal of the refund and specify the reason:',
        },

        create: {
            headerTitle: 'Attention!',
            alert: 'From the date of issue of the order № {id} (issued: {dateDone}) more than 7 days have passed with online payment! By law, the return of an online order is made within 7 days!',
            h3: 'Data sent!',
            textNotProduct: 'The quantity of the returned product is not specified.',
            textNotProductOrNotCommentToCustomer: 'The quantity of the returned product and a comment to the buyer must be indicated.',
            okTitle: 'Confirm',
            cancelTitle: 'Back to the design',
            bvModal: 'Confirm completion of the refund. After confirmation, it will be impossible to correct the data.',
        },

        form: {
            fields: {
                orderId: 'Order №',
                refundFio: "Client's full name",
                refundPhone: "Customer's phone number",
                typeAccount: 'Type of calculation',
                checkingAccount: 'Payment account',
                bankName: 'Name of the bank',
                bik: 'BIC',
                correspondentAccount: 'Correspondent account',
                refundReason: 'Reason for return',
                commentToCustomer: {
                    label: "Buyer's comment",
                    tooltip: 'Fill in the field only if the refund is refused',
                },
            },

            typeAccount: {
                details: 'Bank details',
                card: 'Card',
                cardViaTerminal: 'Card via the terminal',
            },
        },

        formCreate: 'The field must be filled in!',
    },

    index: {
        refundCheck: 'Refund',
        refundList: 'List of refund operations',
        actualReturn: 'Return from the courier service',
        returnFromKuperVitrina: 'Return from the Kuper marketplace',
        taskToReturnFromKuperVitrina: 'Task to return from the Kuper marketplace',
        taskToReturnFromDostavista: 'Задача на возврат из Достависты',
        taskToReturnFromShipping: 'Задача на возврат из доставки {description}',
        partners: 'Partners',
        refundYandex: 'Return from the Yandex.Eda',
    },

    yandex: {
        loadFile: 'Upload register file',
        availableFormats: 'Available formats: XLSX',
        errorFile: 'Error loading file. Try again.',
        order: 'Order №',
        refundAccepted: 'Returns accepted',
        allRefundsConfirmed: 'All returns from the register are confirmed. Finish working with the register?',
        refundsNotConfirmed: 'Not all orders have been confirmed. Are you sure you want to close the page?',
        refundInformer: 'Order #{orderId} has already been confirmed',
        allRefundsConfirmedBefore: 'Returns for these orders have already been accepted, go to view transactions?',
        fields: {
            sku: 'SKU',
            productName: 'Name',
            refundQuantity: 'Items',
            refundCost: 'Amount',
        },
        totalFields: {
            orders: 'Number of orders with returns',
            sum: 'Total amount of all returns',
            productsQuantity: 'Total quantity of goods',
            unacceptedOrders: 'Number of unaccepted orders',
            correctionOrders: 'Number of orders with accounting adjustments',
        },
        acceptAllRefunds: 'Accept all returns',
        transactionDate: 'Posting date',
        transactionDateWarning: 'The posting date should not be later than the date of the cash transfer on the register',
        total: 'Total:',
        collapse: 'Collapse',
        expand: 'Expand',
        refund: 'Refund',
        accountingAdjustments: 'Accounting adjustments',
        refundCollapsed: 'Return {count} pcs. {sum} rub.',
        accountingAdjustmentsCollapsed: 'Accounting adjustments {count} pcs. {sum} rubles.',
        confirmRefund: 'Confirm Return',
    },

    kuperVitrinaFields: {
        order: 'Order',
        originalOrder: '№ order Sbermarket',
        pfm: 'Code of the store PFM',
        status: 'Status',
        action: 'Action',
    },

    details: {
        fields: {
            order: 'Order №',
            pfm: 'PFM store code',
            initiator: 'Initiator of the operation',
            client: 'Customer',
            refundReason: 'Reason for return',
            payTypeName: 'Order payment method',
            payerName: "Client's name",
            payerPhone: "Customer's contact phone number",
            refundType: 'Refund method',
            deliveryServiceMethodName: 'Delivery method',
            checkingAccount: 'Payment account',
            bankName: 'Name of the bank',
            correspondentAccount: 'Correspondent account',
            orderRefundSap: 'SAP Return Number',
            partnerName: 'Источник заказа',
        },

        index: {
            order: 'Order refund operation № {orderId}',
            products: 'Total refund amount',
            totalToBeReturned: 'Total refundable',
            delivery: 'Delivery',
            goodsAmount: 'Sum of goods',
            partners: 'Partners',
        },
    },

    filter: {
        notFound: 'Found {count} operations | Found {count} operation | Found {count} operation | Found {count} operation | Found {count} operations',
    },

    print: {
        info: 'Application for return with delivery',
        content: [
            'To the General Director \n',
            'Best Price Limited Liability Company\n',
            'Kirsanov D.N.\n',
            'from _________________________________________________\n',
            '(Full name)\n',
            'passport series ______№_________________________\n',
            'issued by: by whom ____________________________________\n',
            'when   «    »______________________________г.\n',
            'telephone _______________________________________',
            'APPLICATION FOR RETURN OF GOODS',
            'I _____________________________________________________________________________________________',
            'purchased in your store by order № ________________ product: \n',
            'what is confirmed by the cash receipt _______________________ FD ___________________________',
            'The specified product ____________________________________________________________________________',
            '(reason for return)',
            'I ask you to return the amount of money paid for the goods in the amount of \n',
            '__________ rub. ________ kop.',
            '(amount in words)',
            'By bank transfer to banking details:',
            'Name of the bank: _______________________________________________________________________',
            'BIC bank: __________________________________________________________________________________',
            'Current account number: ____________________________________________________________________',
            'Date',
            'Signature',
            'Decryption of the signature',
        ],

        buttonPdf: 'Printing a return request with delivery',
    },

    areYouSure: 'Are you sure you want to confirm the refund?',

    actual: {
        fields: {
            type: 'Task type',
            priority: 'Priority',
            status: 'Status',
        },
        service: {
            priority: 'High',
            status: 'Not completed',
        },
    },

    fieldsView: {
        orderId: 'Order',
        pfm: 'PFM Store Code',
        tare: 'Containers in the order',
        orderStatus: 'Status',
        printTransfer: 'Transfer documents',
        partnerOrder: "№ partner's order",
        actions: 'Action',
    },

    error: {
        action: 'Failed to complete the action',
    },

    filterFields: {
        orderId: 'Order number',
        pfm: 'PFM Store Code',
        deliveryService: 'Delivery Service',
    },
};